import { render, staticRenderFns } from "./GsTemplatePreview.vue?vue&type=template&id=4a006a6e&v-if=previewStuff&"
import script from "./GsTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./GsTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./GsTemplatePreview.vue?vue&type=style&index=0&id=4a006a6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports